<!--
 * @Description: 特价会场
 * @Autor: kangpeng
 * @Date: 2020-04-20 09:42:10
 * @LastEditors: kangpeng
 * @LastEditTime: 2020-06-15 17:01:59
 -->
<template>
    <div class="venue_center_wrap">
        <div class="breadcrumb_wrap">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>会场中心</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="screen_form">
            <el-form :model="sceenForm" label-position="left" size="small">
                <el-form-item label="地理位置 :">
                    <el-row type="flex">
                        <el-col :span="1" style="margin-right:10px">
                            <span
                                :class="locationState ? 'show_main_color' : 'base_color'"
                                @click="handleChoose('location')"
                            >不限</span>
                        </el-col>
                        <el-col :span="23">
                            <el-row>
                                <div style="display:flex;">
                                    <div
                                        @click="handleChangeCurr('isShowDistrict')"
                                        class="district address_name"
                                    >
                                        <span>
                                            行政/商业区
                                            <i
                                                :class="addressStates.isShowDistrict ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                                            ></i>
                                        </span>
                                    </div>
                                    <!-- <div
                                        @click="handleChangeCurr('isShowBusiness')"
                                        class="business_zone address_name"
                                    >
                                        <span>
                                            商业区
                                            <i
                                                :class="addressStates.isShowBusiness ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                                            ></i>
                                        </span>
                                    </div>-->
                                    <div
                                        @click="handleChangeCurr('isShowSubwayInfo')"
                                        class="around_the_subway"
                                    >
                                        <span>
                                            地铁周边
                                            <i
                                                :class="addressStates.isShowSubwayInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                                            ></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="show_district_box">
                                    <div v-show="addressStates.isShowDistrict">
                                        <el-tabs
                                            v-model="currentAreaTabsName"
                                            @tab-click="handleChooseCityItem"
                                        >
                                            <el-tab-pane
                                                v-for="item in initAddressData.cityList"
                                                :label="item.cityName"
                                                :name="item.cityName"
                                                :key="item.cityId"
                                            >
                                                <div class="station_box">
                                                    <el-radio-group
                                                        v-model="sceenForm.cityChildName"
                                                    >
                                                        <el-radio
                                                            @change="handleAreaChange(business)"
                                                            style="margin-bottom:8px"
                                                            v-for="business in businessData"
                                                            :label="business.name"
                                                            :key="business.id"
                                                        >{{business.name}}</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </el-tab-pane>
                                        </el-tabs>
                                        <!-- <el-radio-group v-model="sceenForm.city">
                                            <el-radio
                                                style="margin-bottom:8px;"
                                                v-for="item in initAddressData.cityList"
                                                :label="item.cityName"
                                                :key="item.cityId"
                                            >{{item.cityName}}</el-radio>
                                        </el-radio-group>-->
                                    </div>
                                </div>
                                <!-- <div class="show_business_box">
                                    <div v-show="addressStates.isShowBusiness">
                                        <el-radio-group v-model="sceenForm.cityChildName">
                                            <el-radio
                                                style="margin-bottom:8px"
                                                v-for="item in initAddressData.cityChildList"
                                                :label="item.cityChildName"
                                                :key="item.cityChildId"
                                            >{{item.cityChildName}}</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>-->
                                <div class="show_subway_box">
                                    <div v-show="addressStates.isShowSubwayInfo">
                                        <div class="title">
                                            <el-tabs @tab-click="handleChooseMetroItem">
                                                <el-tab-pane
                                                    v-for="item in initAddressData.metroList"
                                                    :label="item.metroName"
                                                    :name="String(item.metroId)"
                                                    :key="item.metroId"
                                                >
                                                    <div class="station_box">
                                                        <el-radio-group
                                                            v-model="sceenForm.metroChildName"
                                                        >
                                                            <el-radio
                                                                @change="handleMetroChange(metro)"
                                                                style="margin-bottom:8px"
                                                                v-for="metro in metroStationData"
                                                                :label="metro.metroChildName"
                                                                :key="metro.metroChildId"
                                                            >{{metro.metroChildName}}</el-radio>
                                                        </el-radio-group>
                                                    </div>
                                                </el-tab-pane>
                                            </el-tabs>
                                        </div>
                                    </div>
                                </div>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="场地类型 :">
                    <el-row type="flex">
                        <el-col :span="1" style="margin-right:10px">
                            <span
                                :class="fieldTypeListState ? 'show_main_color' : 'base_color'"
                                @click="handleChoose('fieldTypeList')"
                            >不限</span>
                        </el-col>
                        <el-col :span="23">
                            <el-checkbox-group v-model="sceenForm.fieldTypeList">
                                <el-checkbox
                                    v-for="(item,index) in initFieldTypes"
                                    :label="item"
                                    :key="index"
                                >{{item}}</el-checkbox>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="容纳人数 :">
                    <el-row type="flex">
                        <el-col :span="1" style="margin-right:10px">
                            <span
                                :class="capacityState ? 'show_main_color' : 'base_color'"
                                @click="handleChoose('capacity')"
                            >不限</span>
                        </el-col>
                        <el-col :span="23">
                            <el-radio-group v-model="sceenForm.capacity">
                                <el-radio label="10-50">10-50人</el-radio>
                                <el-radio label="51-100">51-100人</el-radio>
                                <el-radio label="101-200">101-200人</el-radio>
                                <el-radio label="201-300">201-300人</el-radio>
                                <el-radio label="301-500">301-500人</el-radio>
                                <el-radio label="501-1000">501-1000人</el-radio>
                                <el-radio label="1000">1000人以上</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="会场面积 :">
                    <el-row type="flex">
                        <el-col :span="1" style="margin-right:10px">
                            <span
                                :class="areaState ? 'show_main_color' : 'base_color'"
                                @click="handleChoose('area')"
                            >不限</span>
                        </el-col>
                        <el-col :span="23">
                            <el-radio-group v-model="sceenForm.area">
                                <el-radio label="0-100">0-100㎡</el-radio>
                                <el-radio label="101-200">101-200㎡</el-radio>
                                <el-radio label="201-300">201-300㎡</el-radio>
                                <el-radio label="301-500">301-500㎡</el-radio>
                                <el-radio label="501-1000">501-1000㎡</el-radio>
                                <el-radio label="1001-1500">1001-1500㎡</el-radio>
                                <el-radio label="1500">1500㎡以上</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="会场价格 :">
                    <el-row type="flex">
                        <el-col :span="1" style="margin-right:10px">
                            <span
                                :class="fieldPriceState ? 'show_main_color' : 'base_color'"
                                @click="handleChoose('fieldPrice')"
                            >不限</span>
                        </el-col>
                        <el-col :span="23">
                            <el-radio-group v-model="sceenForm.fieldPrice">
                                <el-radio label="0-2000">0-2000元</el-radio>
                                <el-radio label="2001-5000">2001-5000元</el-radio>
                                <el-radio label="5001-10000">5001-10000元</el-radio>
                                <el-radio label="10001-50000">10001-50000元</el-radio>
                                <el-radio label="50001-80000">50001-80000元</el-radio>
                                <el-radio label="80000">80000元以上</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </el-form-item>
                <!-- <el-form-item label="会场特色 :">
                    <el-row type="flex">
                        <el-col :span="1" style="margin-right:10px">
                            <span
                                :class="tagListState ? 'show_main_color' : 'base_color'"
                                @click="handleChoose('tagList')"
                            >不限</span>
                        </el-col>
                        <el-col :span="23">
                            <el-checkbox-group v-model="sceenForm.tagList">
                                <el-checkbox
                                    v-for="(item,index) in initFieldTrait.slice(0,10)"
                                    :label="item.name"
                                    :key="index"
                                ></el-checkbox>
                                <el-collapse-transition>
                                    <div v-show="showMore">
                                        <el-checkbox
                                            v-for="(item,index) in initFieldTrait.slice(10,initFieldTrait.length)"
                                            :label="item.name"
                                            :key="index"
                                        ></el-checkbox>
                                    </div>
                                </el-collapse-transition>
                            </el-checkbox-group>
                            <div class="show_more" @click="showMore = !showMore">
                                <span>{{showMore ? '收起' : '展开更多'}}</span>
                                <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                            </div>
                        </el-col>
                    </el-row>
                </el-form-item> -->
            </el-form>
        </div>
        <div class="num_box">
            <div>
                <div class="tags_wrap">
                    <span v-if="fieldListData.length">
                        共为您匹配到
                        <span style="color:#FF5722;font-size:20px;font-weight:bold">{{total}}</span> 家会议场地
                    </span>
                    <span v-if="tagsList.length">
                        <span class="front">当前筛选条件 :</span>
                        <el-tag
                            size="small"
                            v-for="(tag,index) in tagsList"
                            :key="index"
                            closable
                            @close="handleCloseTag(tag)"
                        >{{tag.name}}</el-tag>
                        <el-button type="text" @click="handleCleanAll">清空条件</el-button>
                    </span>
                </div>
            </div>
        </div>

        <div class="has_data" v-if="fieldListData && fieldListData.length ">
            <div class="tabs_wrap">
                <el-menu
                    :default-active="currActive"
                    mode="horizontal"
                    @select="handleSelect"
                    background-color="#fff"
                    text-color="#000"
                    active-text-color="#10baaa"
                >
                    <el-menu-item index="1">全部场地</el-menu-item>
                    <el-menu-item index="2">只看认证会场</el-menu-item>
                    <el-menu-item index="3">只看优惠场地</el-menu-item>
                    <el-submenu index="4">
                        <template slot="title">智能排序</template>
                        <el-menu-item index="4-1">价格由低到高</el-menu-item>
                        <el-menu-item index="4-2">价格由高到低</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div class="filed_list_wrap">
                <div class="filed_left">
                    <ul class="filed_list">
                        <li class="filed_item" v-for="(filed,index) in fieldListData" :key="index">
                            <div class="swiper_wrap">
                                <swiper
                                    @click="handleTofiledDetail(filed.storeId)"
                                    class="swiper gallery-top"
                                    :options="swiperOptionTop"
                                    ref="swiperTop"
                                >
                                    <swiper-slide v-for="(pic,index) in filed.urls" :key="index">
                                        <img
                                            class="slide_big"
                                            :src="`${pic}?x-oss-process=style/watermark`"
                                            alt
                                        />
                                    </swiper-slide>
                                    <!-- <div
                                    class="swiper-button-next swiper-button-white"
                                    slot="button-next"
                                ></div>
                                <div
                                    class="swiper-button-prev swiper-button-white"
                                    slot="button-prev"
                                    ></div>-->
                                </swiper>
                                <swiper
                                    class="swiper gallery-thumbs"
                                    :options="swiperOptionThumbs"
                                    ref="swiperThumbs"
                                >
                                    <swiper-slide v-for="(pic,index) in filed.urls" :key="index">
                                        <img
                                            class="slide_small"
                                            :src="`${pic}?x-oss-process=style/watermark`"
                                            alt
                                        />
                                    </swiper-slide>
                                </swiper>
                            </div>
                            <div class="right_info">
                                <div class="top_info">
                                    <div class="left">
                                        <span v-show="filed.isDiscount" class="cheap_tag">优惠</span>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="已验真场地为通过了365会议平台数据真A+级验证的标识。本场所的200+数据通过了平台现场验证。"
                                            placement="bottom-start"
                                        >
                                            <span
                                                v-show="filed.isVerification"
                                                class="checked_tag"
                                            >认证会场</span>
                                        </el-tooltip>
                                        <span
                                            @click="handleTofiledDetail(filed.storeId)"
                                            class="name"
                                        >{{filed.storeName | ellipsis(25)}}</span>
                                        <span class="uniqe">[{{filed.type || '其他'}}]</span>
                                    </div>
                                    <div class="right">
                                        <!-- <span
                                            class="add_to_pk"
                                            @click="handleAddToPk(filed.storeId,filed.storeName)"
                                        >
                                            <span class="plus">+</span>加入对比
                                        </span>-->
                                    </div>
                                </div>
                                <div class="address_wrap">
                                    <span class="address_item">{{filed.region}}</span>
                                    <el-tooltip
                                        effect="dark"
                                        :content="filed.address"
                                        placement="top"
                                    >
                                        <span
                                            class="address_item"
                                        >地址 :{{filed.address | ellipsis(18)}}</span>
                                    </el-tooltip>
                                </div>
                                <div class="desc_info">
                                    <div class="col">
                                        <div class="item">
                                            <span class="label">会场数量 :</span>
                                            <span class="value">{{filed.fieldCount}}间</span>
                                        </div>
                                        <div class="item">
                                            <span class="label">会场面积 :</span>
                                            <span class="value">{{filed.area}}</span>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="item" style="line-height:20px">
                                            <span class="label">会场人数 :</span>
                                            <span class="value">{{filed.capacity}}人</span>
                                        </div>
                                        <div class="item">
                                            <span class="label">会场价格 :</span>
                                            <span
                                                style="color:#FF5722;font-weight:bold;font-size:20px"
                                                class="value"
                                            >
                                                <i style="color:#FF5722;font-size:12px">￥</i>
                                                {{filed.minPrice}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="tag_wrap" v-if="filed.tag">
                                    <span
                                        class="tag_item"
                                        v-for="(tag,index) in filed.tag.split(',')"
                                        :key="index"
                                    >{{tag}}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="pagination_wrap">
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :page-size="size"
                            layout="prev, pager, next, jumper"
                            :total="total"
                        ></el-pagination>
                    </div>
                </div>
                <div class="filed_right">
                    <div class="sticky">
                        <span @click="handleToMap" class="mask_to_map"></span>
                        <baidu-map
                            class="map_wrap"
                            :center="{lng: 113.946397, lat: 22.529211}"
                            :zoom="17"
                            :scroll-wheel-zoom="false"
                        >
                            <bm-marker :position="{lng: 113.946397, lat: 22.529211}">
                                <bm-label
                                    content="ECO国际会议中心"
                                    :labelStyle="{color: 'red', fontSize : '12px'}"
                                    :offset="{width: -35, height: 30}"
                                />
                            </bm-marker>
                        </baidu-map>
                        <!-- <div class="pk_wrap">
                            <ul class="list">
                                <li class="item" v-for="item in pkLists" :key="item.id">
                                    <span>{{item.name | ellipsis(12)}}</span>
                                    <i class="el-icon-close" @click="handleRemoveItem(item.id)"></i>
                                </li>
                            </ul>
                            <div class="look_wrap" :class="pkLists.length ? 'show' : 'hide'">
                                <span class="text" @click="handleToPkDetail">查看对比pk</span>
                            </div>
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="empty_box" v-if="!fieldListData.length && loadingSuccess && !isSeedSuccess">
            <img class="no_data_img" src="../../assets/img/venuecenter_img/empty.png" alt />
            <span class="desc">很抱歉，暂时没有找到符合您要求的会场</span>
            <span class="tips">留下您的联系电话，让我们的会议顾问再帮您找找</span>
            <div class="form_wrap">
                <el-form
                    size="small"
                    label-position="right"
                    label-width="120px"
                    :model="sendForm"
                    :rules="rules"
                >
                    <el-form-item label="手机号 :" prop="sendPhone">
                        <el-input style="width:180px" v-model="sendForm.sendPhone"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="width:180px" type="primary" @click="handleSendNeeds">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <span class="proposal">或者您也可以换个搜索条件再试试</span>
        </div>
        <div class="send_sucess" v-if="!fieldListData.length && loadingSuccess && isSeedSuccess">
            <div class="icon">
                <img src="../../assets/img/venuecenter_img/success.png" alt />
            </div>
            <div class="tips">
                <span class="top">你的反馈提交成功！</span>
                <span class="bottom">稍后会议顾问将会与您联系，请你注意接听来电</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        var validatePhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入手机号码"));
            } else if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(value)) {
                return callback(new Error("手机号码格式有误"));
            } else {
                callback();
            }
        };
        return {
            swiperOptionTop: {
                loop: true,
                loopedSlides: 5, // looped slides should be the same
                spaceBetween: 10
            },
            swiperOptionThumbs: {
                loop: true,
                loopedSlides: 5, // looped slides should be the same
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
                slideToClickedSlide: true
            },
            locationState: true, // 地理位置状态
            fieldTypeListState: true, // 场地类型状态
            capacityState: true, // 容纳人数状态
            areaState: true, // 会场面积状态
            fieldPriceState: true, // 会场价格状态
            tagListState: true, // 会场特色状态
            addressStates: {
                isShowDistrict: false, // 展示行政区信息
                isShowBusiness: false, // 展示商业区信息
                isShowSubwayInfo: false // 展示地铁周边信息
            },
            initFieldTypes: [], // 初始化场地类型数据
            initFieldTrait: [], // 初始化会场特色数据
            initAddressData: [], // 初始化地理位置数据
            metroStationData: [], // 地铁站台数据
            businessData: [], //商业区数据
            sceenForm: {
                city: "",
                cityChildName: "",
                metroName: "",
                metroChildName: "",
                fieldTypeList: [],
                capacity: "",
                area: "",
                fieldPrice: "",
                storeName: "",
                tagList: []
            },
            total: 0,
            page: 1,
            size: 10,
            currActive: "1",
            isVerification: 1,
            fieldListData: [],
            tagsList: [],
            storeId: null,
            pkLists: [],
            sendForm: {
                sendPhone: ""
            },
            rules: {
                sendPhone: [
                    {
                        required: true,
                        validator: validatePhone,
                        trigger: "blur"
                    }
                ]
            },
            isFirst: 1,
            loadingSuccess: false,
            isSeedSuccess: false,
            currentAreaTabsName: "", // 当前选中的行政区名字
            latitude: "", // 纬度
            longitude: "", // 经度
            showMore: false //展示更多会场特色
        };
    },
    computed: {},
    created() {
        this.getTypeAndTraitData();
        this.getAddressData();
    },
    mounted() {
        this.currActive = String(this.$route.query.idx * 1 + 1) || "1";
        this.sceenForm.cityChildName = this.$route.query.id || "";
        this.sceenForm.city = this.$route.query.area || "";
        this.sceenForm.fieldPrice = this.$route.query.fieldPrice || "";
        if (this.sceenForm.city) {
            this.currentAreaTabsName = this.sceenForm.city;
            this.addressStates.isShowDistrict = true;
            this.getBusinessZone(this.currentAreaTabsName);
        }
    },
    watch: {
        /**
         * @description: 筛选条件改变请求
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        sceenForm: {
            handler(newVal) {
                this.page = 1;
                this.tagsList = [];
                setTimeout(() => {
                    this.getScreenList(); // 只要改变就触发请求
                }, 500);
                for (const key in newVal) {
                    if (
                        newVal["city"] !== "" ||
                        newVal["cityChildName"] !== "" ||
                        newVal["metroChildName"] !== ""
                    ) {
                        this["locationState"] = false;
                    }
                    if (key !== "fieldTypeList" && key !== "tagList") {
                        if (newVal[key] != "") {
                            const tempObj1 = {};
                            tempObj1.name = newVal[key];
                            tempObj1.type = key;
                            this.tagsList.push(tempObj1);
                            this[`${key}State`] = false;
                        }
                    } else {
                        if (newVal[key].length == 0) {
                            this[`${key}State`] = true;
                        } else {
                            newVal[key].map(item => {
                                const tempObj2 = {};
                                tempObj2.name = item;
                                tempObj2.type = key;
                                this.tagsList.push(tempObj2);
                            });
                            this[`${key}State`] = false;
                        }
                    }
                }
            },
            immediate: true,
            deep: true
        },
        /**
         * @description: el-menu切换请求
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        currActive() {
            this.getScreenList();
        },
        /**
         * @description: 搜索的时候请求
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        $route(val) {
            if (this.$route.query.storeName) {
                this.getSearchKeyCood();
            }
        }
    },
    methods: {
        /**
         * @description:
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleToMap() {
            let url = this.$router.resolve("/findVenueOnMap");
            window.open(url.href, "_blank");
        },
        /**
         * @description: 行政区/商业区改变触发
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleAreaChange(val) {
            this.sceenForm.metroChildName = "";
            this.latitude = val.latitude;
            this.longitude = val.longitude;
        },
        /**
         * @description: 地铁线路改变触发
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleMetroChange(val) {
            this.sceenForm.cityChildName = "";
            this.latitude = val.latitude;
            this.longitude = val.longitude;
            //this.getScreenList()
        },
        /**
         * @description: 获取场地类型和会场特色筛选数据
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getTypeAndTraitData() {
            this.$get("/api/v1/field/screen")
                .then(res => {
                    if (res.code == 200) {
                        this.initFieldTypes = res.data.typeList;
                        this.initFieldTrait = res.data.tagList;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 获取地理位置数据
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getAddressData() {
            this.$get("/api/v1/storeWebsite/resultCityInit")
                .then(res => {
                    if (res.code == 200) {
                        this.initAddressData = res.data;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 点击不限的逻辑
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleChoose(type) {
            this[`${type}State`] = true;
            this.handleChangeCurr();
            // this.getScreenList();
            for (const key in this.sceenForm) {
                if (type == key) {
                    if (key == "fieldTypeList" || key == "tagList") {
                        this.sceenForm[key] = [];
                    } else {
                        this.sceenForm[key] = "";
                    }
                } else if (type == "location") {
                    // 解决选择行政区后再点击'不限'经纬度还存在的bug 2020-05-26
                    this.latitude = "";
                    this.longitude = "";
                    if (
                        this.sceenForm["city"] !== "" ||
                        this.sceenForm["cityChildName"] !== "" ||
                        this.sceenForm["metroChildName"] !== ""
                    ) {
                        this.sceenForm.city = "";
                        this.sceenForm.cityChildName = "";
                        this.sceenForm.metroChildName = "";
                    }
                }
            }
        },
        /**
         * @description: 选择行政/商业区
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleChooseCityItem(val) {
            this.sceenForm.city = val.name;
            this.sceenForm.cityChildName = "";
            this.latitude = "";
            this.longitude = "";
            this.getBusinessZone(val.label);
        },
        /**
         * @description: 获取商业区列表
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getBusinessZone(val) {
            this.$get("/api/v1/storeWebsite/circleList", { name: val })
                .then(res => {
                    if (res.code == 200) {
                        this.businessData = res.data;
                        // 获取第一个的信息，change事件无法监听第一个
                        // this.sceenForm.cityChildName = this.businessData[0].name;
                        // 行政区和地铁只允许一个存在
                        this.sceenForm.metroChildName = "";
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 选择地铁线路
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleChooseMetroItem(val) {
            let id = Number(val.name);
            this.$get("/api/v1/storeWebsite/selectMetroChild", { id })
                .then(res => {
                    if (res.code == 200) {
                        this.metroStationData = res.data;
                        // 获取第一个的信息，change事件无法监听第一个
                        this.sceenForm.metroChildName = this.metroStationData[0].metroChildName;
                        // 行政区和地铁只允许一个存在
                        this.sceenForm.city = "";
                        this.sceenForm.cityChildName = "";
                        this.latitude = this.metroStationData[0].latitude;
                        this.longitude = this.metroStationData[0].longitude;
                        //this.getScreenList();
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 点击地理位置
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleChangeCurr(val) {
            for (const key in this.addressStates) {
                if (val !== key) {
                    this.addressStates[key] = false;
                } else {
                    this.addressStates[val] = !this.addressStates[val];
                }
            }
            // this[`isShow${val}`] = !this[`isShow${val}`]
        },
        /**
         * @description: 获取筛选后的列表
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getScreenList() {
            const sceenForm = this.sceenForm;
            const tempObj = {};
            if (this.currActive === "1") {
                tempObj.all = "";
                tempObj.isDiscount = "";
            } else if (this.currActive === "2") {
                tempObj.isVerification = 1;
            } else if (this.currActive === "3") {
                tempObj.isDiscount = 1;
            } else if (this.currActive === "4-1") {
                tempObj.isPrice = 1;
            } else if (this.currActive === "4-2") {
                tempObj.isPrice = 0;
            }
            let param = {
                ...tempObj,
                p: this.page,
                s: this.size,
                city: sceenForm.city, //行政区id
                cityChildName: sceenForm.cityChildName, //商业区id
                metroName: sceenForm.metroName, //地铁周边线路id
                metroChildName: sceenForm.metroChildName, //地铁站台id
                fieldTypeList: sceenForm.fieldTypeList, //场地类型id集合
                latitude: this.latitude, //纬度
                longitude: this.longitude, // 经度
                minCapacity:
                    sceenForm.capacity.indexOf("-") == -1
                        ? sceenForm.capacity
                        : sceenForm.capacity.split("-")[0], //最小容纳人数
                maxCapacity:
                    sceenForm.capacity.indexOf("-") == -1
                        ? ""
                        : sceenForm.capacity.split("-")[1], //最大容纳人数
                minArea:
                    sceenForm.area.indexOf("-") == -1
                        ? sceenForm.area
                        : sceenForm.area.split("-")[0], //最大面积
                maxArea:
                    sceenForm.area.indexOf("-") == -1
                        ? ""
                        : sceenForm.area.split("-")[1], //最小面积
                minPrice:
                    sceenForm.fieldPrice.indexOf("-") == -1
                        ? sceenForm.fieldPrice
                        : sceenForm.fieldPrice.split("-")[0], //价格筛选-最小值
                maxPrice:
                    sceenForm.fieldPrice.indexOf("-") == -1
                        ? ""
                        : sceenForm.fieldPrice.split("-")[1], //价格筛选-最大值
                tagList: sceenForm.tagList //特色id集合
            };
            this.$post("/api/v1/storeWebsite/list", param)
                .then(res => {
                    if (res.code == 200) {
                        this.total = res.total;
                        this.fieldListData = res.data;
                        this.fieldListData.map((item, index) => {
                            this.$nextTick(() => {
                                const swiperTop = this.$refs.swiperTop[index]
                                    .$swiper;
                                const swiperThumbs = this.$refs.swiperThumbs[
                                    index
                                ].$swiper;
                                swiperTop.controller.control = swiperThumbs;
                                swiperThumbs.controller.control = swiperTop;
                            });
                        });
                        this.loadingSuccess = true;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 头部搜素关键词
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getSearchKeyCood() {
            let param = {
                p: this.page,
                s: this.size,
                storeName: this.$route.query.storeName
            };
            this.$post("/api/v1/storeWebsite/list", param)
                .then(res => {
                    if (res.code == 200) {
                        this.total = res.total;
                        this.fieldListData = res.data;
                        this.fieldListData.map((item, index) => {
                            this.$nextTick(() => {
                                const swiperTop = this.$refs.swiperTop[index]
                                    .$swiper;
                                const swiperThumbs = this.$refs.swiperThumbs[
                                    index
                                ].$swiper;
                                swiperTop.controller.control = swiperThumbs;
                                swiperThumbs.controller.control = swiperTop;
                            });
                        });
                        this.loadingSuccess = true;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 分页切换
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleCurrentChange(page) {
            this.page = page;
            this.getScreenList();
            this.$router.push({ path: "/venueCenter", query: { page } });
        },
        /**
         * @description: tabs切换
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleSelect(val) {
            this.currActive = val;
        },
        /**
         * @description: 跳转到对应详情
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleTofiledDetail(id) {
            let url = this.$router.resolve({
                path: "/venueDetails",
                query: { id }
            });
            window.open(url.href, "_blank");
        },
        /**
         * @description: 加入对比pk
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleAddToPk(storeId, storeName) {
            let tempObj;
            tempObj = {
                id: storeId,
                name: storeName,
                isClick: true
            };
            if (!this.pkLists.some(item => item.id === tempObj.id)) {
                this.pkLists.push(tempObj);
            } else {
                this.$message.warning("请勿重复添加");
            }
        },
        /**
         * @description:
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleRemoveItem(id) {
            let removeIndex = this.pkLists.findIndex(item => item.id === id);
            this.pkLists.splice(removeIndex, 1);
        },
        /**
         * @description: 跳转到pk详情
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleToPkDetail() {
            if (this.pkLists.length) {
            } else if (this.pkLists.length == 1) {
                this.$message.warning("请至少添加2条pk数据");
            } else {
                this.$message.warning("请先添加pk数据");
            }
        },
        /**
         * @description: 提交手机号
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleSendNeeds() {
            const sceenForm = this.sceenForm;
            let param = {
                phone: this.sendForm.sendPhone,
                city: sceenForm.city, //行政区id
                cityChildName: sceenForm.cityChildName, //商业区id
                metroName: sceenForm.metroName, //地铁周边线路id
                metroChildName: sceenForm.metroChildName, //地铁站台id
                fieldTypeList: sceenForm.fieldTypeList, //场地类型id集合
                minCapacity:
                    sceenForm.capacity.indexOf("-") == -1
                        ? sceenForm.capacity
                        : sceenForm.capacity.split("-")[0], //最小容纳人数
                maxCapacity:
                    sceenForm.capacity.indexOf("-") == -1
                        ? ""
                        : sceenForm.capacity.split("-")[1], //最大容纳人数
                minArea:
                    sceenForm.area.indexOf("-") == -1
                        ? sceenForm.area
                        : sceenForm.area.split("-")[0], //最大面积
                maxArea:
                    sceenForm.area.indexOf("-") == -1
                        ? ""
                        : sceenForm.area.split("-")[1], //最小面积
                minPrice:
                    sceenForm.fieldPrice.indexOf("-") == -1
                        ? sceenForm.fieldPrice
                        : sceenForm.fieldPrice.split("-")[0], //价格筛选-最小值
                maxPrice:
                    sceenForm.fieldPrice.indexOf("-") == -1
                        ? ""
                        : sceenForm.fieldPrice.split("-")[1], //价格筛选-最大值
                tagList: sceenForm.tagList //特色id集合
            };
            this.$post("/api/v1/storeWebsite/seachSubmit", param)
                .then(res => {
                    if (res.code == 200) {
                        this.isSeedSuccess = true;
                    }
                })
                .catch(err => {});
        },
        /**
         * @description: 删除标签的处理
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleCloseTag(tag) {
            if (tag.type == "metroChildName" || tag.type == "cityChildName") {
                this.sceenForm.city = "";
                this.sceenForm.cityChildName = "";
                this.sceenForm.metroName = "";
                this.sceenForm.metroChildName = "";
                this.longitude = "";
                this.latitude = "";
                this.locationState = true;
                this.addressStates = {
                    isShowDistrict: false, // 展示行政区信息
                    isShowSubwayInfo: false // 展示地铁周边信息
                };
                // this.$router.push("/venueCenter");
            }
            this.tagsList.splice(
                this.tagsList.findIndex(item => item.name == tag.name),
                1
            );
            let flag = true;
            for (const key in this.sceenForm) {
                if (
                    (tag.type == "fieldTypeList" || "tagList") &&
                    Array.isArray(this.sceenForm[tag.type])
                ) {
                    if (flag) {
                        this.sceenForm[tag.type].splice(
                            this.sceenForm[tag.type].indexOf(tag.name),
                            1
                        );
                        flag = false;
                    }
                } else {
                    if (
                        tag.type == "capacity" ||
                        tag.type == "area" ||
                        tag.type == "fieldPrice"
                    ) {
                        this.sceenForm[tag.type] = "";
                        this[`${tag.type}State`] = true;
                        break;
                    }
                }
            }
            flag = true;
        },
        /**
         * @description: 清空条件
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleCleanAll() {
            this.$router.push("/venueCenter");
            this.tagsList = [];
            this.sceenForm = {
                city: "",
                cityChildName: "",
                metroName: "",
                metroChildName: "",
                fieldTypeList: [],
                capacity: "",
                area: "",
                fieldPrice: "",
                tagList: []
            };
            (this.addressStates = {
                isShowDistrict: false, // 展示行政区信息
                isShowSubwayInfo: false // 展示地铁周边信息
            }),
                (this.locationState = true); // 地理位置状态
            this.fieldTypeListState = true; // 场地类型状态
            this.capacityState = true; // 容纳人数状态
            this.areaState = true; // 会场面积状态
            this.fieldPriceState = true; // 会场价格状态
            this.tagListState = true; // 会场特色状态
            this.longitude = "";
            this.latitude = "";
        }
    }
};
</script>

<style scoped lang="stylus">
.show_main_color
    padding 2px 4px
    border-radius 2px
    cursor pointer
    color #fff
    background #10baaa
.base_color
    color #000
    cursor pointer
.address_name
    margin-right 15px
.district, .business_zone, .around_the_subway
    cursor pointer
.show_more
    font-size 12px
    color #10baaa
    cursor pointer
    text-align center
.show_subway_box
    .metro_item
        padding 5px 10px
        cursor pointer
.venue_center_wrap
    width 1200px
    min-height calc(100vh - 220px - 88px)
    margin 0 auto
    .breadcrumb_wrap
        >>>.el-breadcrumb
            font-size 12px
        height 60px
        display flex
        align-items center
    .screen_form
        border-bottom 1px solid #E7E7E7
    .num_box
        margin-top 17px
        .tags_wrap
            .front
                font-size 14px
                margin-right 10px
            >>>.el-tag
                margin-right 5px
    .empty_box
        margin-top 30px
        margin-bottom 90px
        width 1200px
        height 400px
        box-sizing border-box
        padding 30px 80px
        border 1px solid #D4D4D4
        display flex
        flex-direction column
        align-items center
        .no_data_img
            width 64px
            height 64px
            margin-bottom 18px
        .desc
            width 100%
            text-align center
            font-size 22px
            font-weight bold
            padding-bottom 33px
            border-bottom 1px dashed #BFBFBF
        .tips
            color #FF5722
            margin-top 28px
            margin-bottom 30px
        .form_wrap
            width 350px
        .proposal
            font-size 14px
    .send_sucess
        margin-top 30px
        margin-bottom 90px
        width 1200px
        height 280px
        border 1px solid #D4D4D4
        display flex
        box-sizing border-box
        padding 30px 50px
        .icon
            margin-right 20px
            img
                width 100px
                height 100px
        .tips
            display flex
            width calc(100% - 120px)
            flex-direction column
            align-items flex-start
            justify-content flex-start
            .top
                width 100%
                padding 20px 0
                color #00b000
                border-bottom 1px dashed #BFBFBF
            .bottom
                color #F18E00
                font-size 14px
                margin-top 20px
    .tabs_wrap
        width 100%
        margin-top 24px
        position -webkit-sticky
        position -moz-sticky
        position -ms-sticky
        position sticky
        background-color #fff
        top 88px
        z-index 888
        .el-menu
            height 40px
        .el-menu-item
            height 40px
            line-height 40px
        >>>.el-submenu__title
            height 40px
            line-height 40px
        .el-menu.el-menu--horizontal
            border-bottom 1px solid #10baaa
    .filed_list_wrap
        display flex
        .filed_left
            flex 0 0 65%
            .filed_list
                .filed_item
                    padding 25px 0
                    display flex
                    border-bottom 1px solid #ddd
                    .swiper_wrap
                        cursor pointer
                        width 243px
                        height 166px
                        background-color #000
                        .swiper
                            .swiper-slide
                                background-size cover
                                background-position center
                                .slide_big
                                    width 243px
                                    height 130px
                                .slide_small
                                    width 60px
                                    height 36px
                            &.gallery-top
                                height 80%
                                width 100%
                            &.gallery-thumbs
                                height 20%
                                box-sizing border-box
                            &.gallery-thumbs .swiper-slide
                                width 25%
                                height 100%
                                opacity 0.4
                            &.gallery-thumbs .swiper-slide-active
                                opacity 1
                    .right_info
                        width calc(100% - 233px)
                        margin-left 10px
                        .top_info
                            display flex
                            justify-content space-between
                            .left
                                .cheap_tag
                                    background #FF5722
                                    font-size 12px
                                    border-radius 4px
                                    color #fff
                                    padding 2px 4px
                                    margin-right 5px
                                .checked_tag
                                    cursor pointer
                                    background #10baaa
                                    font-size 12px
                                    border-radius 4px
                                    color #fff
                                    margin-right 5px
                                    padding 2px 4px
                                .name
                                    font-size 18px
                                    font-weight bold
                                    cursor pointer
                                    margin-right 6px
                                    &:hover
                                        color #10baaa
                                .uniqe
                                    font-size 12px
                                    color #ff5722
                            .right
                                .add_to_pk
                                    cursor pointer
                                    color #10baaa
                                    font-size 12px
                                    font-weight bold
                                    padding 4px 8px
                                    border-radius 3px
                                    border 1px solid #10baaa
                                    .plus
                                        font-size 16px
                                    &:hover
                                        background #10baaa
                                        color #fff
                                        transition all 0.28s ease-out
                        .address_wrap
                            font-size 12px
                            margin-top 25px
                            display flex
                            justify-content space-between
                            .address_item
                                width 50%
                        .desc_info
                            font-size 12px
                            .col
                                display flex
                                margin-top 20px
                                justify-content flex-start
                                .item
                                    width 50%
                        .tag_wrap
                            margin-top 10px
                            .tag_item
                                padding 2px 4px
                                font-size 12px
                                color #10baaa
                                border-radius 3px
                                margin-right 6px
                                border 1px solid #10baaa
        .filed_right
            flex 0 0 30%
            margin-left 5%
            .sticky
                position -webkit-sticky
                position -moz-sticky
                position -ms-sticky
                position sticky
                top 146px
                z-index 888
                .mask_to_map
                    cursor pointer
                    position absolute
                    left 0
                    bottom 0
                    width 100%
                    z-index 999
                    height 83px
                    background url('../../assets/img/venuecenter_img/map.png') center center no-repeat
                .map_wrap
                    width 100%
                    height 300px
                    margin-top 25px
                .pk_wrap
                    width 100%
                    margin-top 24px
                    .list
                        display flex
                        flex-direction column
                        box-sizing border-box
                        background #F5F5F5
                        padding 0 15px
                        .item
                            height 40px
                            color #333
                            display flex
                            justify-content space-between
                            align-items center
                            font-size 12px
                            border-bottom 1px solid #E6E6E6
                            i
                                color red
                                font-size 16px
                                cursor pointer
                    .look_wrap
                        height 30px
                        cursor pointer
                        font-size 12px
                        color #fff
                        background #10BAAA
                        text-align center
                        line-height 30px
                    .show
                        background #10BAAA
                    .hide
                        background #bdbdbd
        .pagination_wrap
            height 200px
            display flex
            justify-content flex-end
            align-items center
</style>
